<template lang="html">
  <div class="card-container">
    <slot />
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: {
      labelText: {
        type: String,
        default() {
          return '';
        },
      },
    },
    methods: {},
  };
</script>

<style scoped lang="stylus">

  /****** Import Global Stylus ******/

  @import '~app/global-stylus'

  /****** Defaults ******/

  .card-container
    border-radius: 2px
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)
    transition: box-shadow .2s
    min-height: 200px;
    &:hover
      cursor: pointer
      box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)
      transition: box-shadow .2s
</style>



// WEBPACK FOOTER //
// plCard.vue?95f60692